import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";

const device = Klass("Console").device;

export default {
	/**
	 * 入力用部品を生成
	 * @param {String} pk
	 * @param {String} inpType
	 * @param {Object} pi
	 * @returns {$Object}
	 */
	_createInputParts(pk, inpType, pi) {
		const $elm = $("<div/>").attr({
			"data-name": pk,
			"data-type": inpType
		});
		
		const { inputIdPrefix } = this;
		
		switch(inpType) {
			case "flg": {
				$elm.attr({
					"id": `area_${inputIdPrefix}_${pk}`
				}).addClass("area-checkbox");
				
				const className = `inp inp-checkbox ${this.inputClassName}`;
				
				// dataOptionはArray
				$.fn.append.apply(
					$elm,
					[].concat(pi.dataOption).reverse().map((v, i) => {
						const idx = Math.abs(i - 1);
						const idStr = `${inputIdPrefix}_${pk}_${idx}`;
						return $("<span/>").addClass("field-inp").append(
							$("<input/>").addClass(className).attr({
								type: "checkbox",
								name: `${pk}[]`,
								id: idStr
							}).val(idx).prop("checked", true),
							$("<label/>").addClass("hover-target").attr("for", idStr).append(
								$("<span/>").addClass(`${pk}-${idx}`).text(v)
							)
						);
					})
				);
				break;
			}
			
			case "radio":
			case "checkbox": {
				$elm.attr({
					"id": `area_${inputIdPrefix}_${pk}`
				}).addClass("area-checkbox");
				
				const className = `inp inp-checkbox ${this.inputClassName}`;
				
				// dataOptionはObjectかArray
				if( Array.isArray(pi.dataOption) ) {
					$.fn.append.apply(
						$elm,
						pi.dataOption.map((v, i) => {
							const idStr = `${inputIdPrefix}_${pk}_${i}`;
							return $("<span/>").addClass("field-inp").append(
								$("<input/>").addClass(className).attr({
									type: "checkbox",
									name: `${pk}[]`,
									id: idStr
								}).val(i).prop("checked", true),
								$("<label/>").addClass("hover-target").attr("for", idStr).append(
									$("<span/>").addClass(`${pk}-${i}`).text(v)
								)
							);
						})
					);
					
				} else {
					$.fn.append.apply(
						$elm,
						Object.keys(pi.dataOption).map(k => {
							const idStr = `${inputIdPrefix}_${pk}_${k}`;
							const v = pi.dataOption[k];
							return $("<span/>").addClass("field-inp").append(
								$("<input/>").addClass(className).attr({
									type: "checkbox",
									name: `${pk}[]`,
									id: idStr
								}).val(k).prop("checked", true),
								$("<label/>").addClass("hover-target").attr("for", idStr).append(
									$("<span/>").addClass(`${pk}-${k}`).text(v)
								)
							);
						})
					);
				}
				
				if(this.searchParams[pk]) {
					// 選択肢の数を保持
					this.searchParams[pk].optLength = $elm.children().length;
				}
				break;
			}
			
			case "select": {
				const $inp = $("<select/>").addClass(`inp ${this.inputClassName}`).attr({
					id: `${inputIdPrefix}_${pk}`,
					name: pk
				}).append(
					$("<option/>").val("").text("全て").prop("selected", true)
				);
				
				// dataOptionはObjectかArray
				if( Array.isArray(pi.dataOption) ) {
					$.fn.append.apply(
						$inp,
						pi.dataOption.map( (v, i) => $("<option/>").val(i).text(v) )
					);
					
				} else {
					$.fn.append.apply(
						$inp,
						Object.keys(pi.dataOption).map(k => {
							return $("<option/>").val(k).text(pi.dataOption[k])
						})
					);
				}
				$inp.appendTo($elm);
				break;
			}
			
			case "date":
			case "datetime": {	// datetimeもdate扱いとする
				$("<input/>").attr({
					type: device[0] === "pc" ? "text" : "date",
					name: pk,
					id: `${inputIdPrefix}_${pk}`,
					maxlength: 16
				}).addClass(`inp inp-date ${this.inputClassName}`).appendTo($elm);
				break;
			}
			
			case "period": {
				$elm.addClass("area-period");
				if(pi.inpType && pi.inpType === "period") {
					const inpType = (device[0] === "pc") ? "text" : "date";
					$elm.append(
						// 開始日
						$("<span/>").addClass("field-inp").attr("data-period", "start").append(
							$("<input/>").attr({
								type: inpType,
								name: `${pk}_s_from`,
								id: `${inputIdPrefix}_${pk}_s_from`,
								title: "開始日 (from)",
								maxlength: 16
							}).addClass(`inp inp-date day-from ${this.inputClassName}`),
							$("<span/>").addClass("period-splitter"),
							$("<input/>").attr({
								type: inpType,
								name: `${pk}_s_to`,
								id: `${inputIdPrefix}_${pk}_s_to`,
								title: "開始日 (to)",
								maxlength: 16
							}).addClass(`inp inp-date day-to ${this.inputClassName}`)
						),
						// splitter
						$("<span/>").addClass("period-splitter"),
						// 終了日
						$("<span/>").addClass("field-inp").attr("data-period", "end").append(
							$("<input/>").attr({
								type: inpType,
								name: `${pk}_e_from`,
								id: `${inputIdPrefix}_${pk}_e_from`,
								title: "終了日 (from)",
								maxlength: 16
							}).addClass(`inp inp-date day-from ${this.inputClassName}`),
							$("<span/>").addClass("period-splitter"),
							$("<input/>").attr({
								type: inpType,
								name: `${pk}_e_to`,
								id: `${inputIdPrefix}_${pk}_e_to`,
								title: "終了日 (to)",
								maxlength: 16
							}).addClass(`inp inp-date day-to ${this.inputClassName}`)
						),
						// 設定ボタン、ウインドウ
						$("<span/>").addClass("period-config").attr("title", "検索設定").append(
							$("<span/>").addClass("btn-toggle icon-before hover-target").attr({
								"data-icon": "config"
							}),
							$("<span/>").addClass("config-window area-radio").append(
								$("<a/>").addClass("btn-close icon-before").attr({
									"href": "./",
									"title": "閉じる",
									"data-icon": "close"
								}),
								$("<span/>").addClass("field-inp").attr("data-val", "b").append(
									$("<input/>").attr({
										type: "radio",
										name: `${pk}_conf`,
										id: `${inputIdPrefix}_${pk}_conf_b`
									}).val("b").addClass("inp inp-radio"),
									$("<label/>").attr({
										"for": `${inputIdPrefix}_${pk}_conf_b`,
										"title": "指定した期間中に表示されるデータを検索します"
									}).append( $("<span/>").text("期間で検索") )
								),
								$("<span/>").addClass("field-inp").attr("data-val", "s").append(
									$("<input/>").attr({
										type: "radio",
										name: `${pk}_conf`,
										id: `${inputIdPrefix}_${pk}_conf_s`
									}).val("s").addClass("inp inp-radio"),
									$("<label/>").attr({
										"for": `${inputIdPrefix}_${pk}_conf_s`,
										"title": "開始日を検索対象とします"
									}).append( $("<span/>").text("開始日で検索") )
								),
								$("<span/>").addClass("field-inp").attr("data-val", "e").append(
									$("<input/>").attr({
										type: "radio",
										name: `${pk}_conf`,
										id: `${inputIdPrefix}_${pk}_conf_e`
									}).val("e").addClass("inp inp-radio"),
									$("<label/>").attr({
										"for": `${inputIdPrefix}_${pk}_conf_e`,
										"title": "終了日を検索対象とします"
									}).append( $("<span/>").text("終了日で検索") )
								),
								$("<span/>").addClass("field-inp").attr("data-val", "a").append(
									$("<input/>").attr({
										type: "radio",
										name: `${pk}_conf`,
										id: `${inputIdPrefix}_${pk}_conf_a`
									}).val("a").addClass("inp inp-radio"),
									$("<label/>").attr({
										"for": `${inputIdPrefix}_${pk}_conf_a`,
										"title": "開始日・終了日ともに範囲指定をして検索します"
									}).append( $("<span/>").text("詳細検索") )
								)
							).css("display", "none")
						)
					);
					
				} else {
					// date, datetime
					$elm.append(
						$("<input/>").attr({
							type: "text",
							name: `${pk}_from`,
							id: `${inputIdPrefix}_${pk}_from`,
							maxlength: 16
						}).addClass(`inp inp-date day-from ${this.inputClassName}`),
						$("<span/>").addClass("period-splitter"),
						$("<input/>").attr({
							type: "text",
							name: `${pk}_to`,
							id: `${inputIdPrefix}_${pk}_to`,
							maxlength: 16
						}).addClass(`inp inp-date day-to ${this.inputClassName}`)
					);
				}
				break;
			}
			
			case "number": {
				const $inp = $("<input/>").attr({
					type: device[0] === "pc" ? "text" : "tel",
					name: pk,
					id: `${inputIdPrefix}_pk`,
					maxlength: 255
				}).addClass(`inp inp-txt inp-num ${this.inputClassName}`);
				
				!!pi.ltd && $inp.attr({
					"data-mask": u_.zeroPadding(0, pi.ltd)
				});
				
				$inp.appendTo($elm);
				break;
			}
			
			default: {
				$("<input/>").attr({
					type: "text",
					name: pk,
					id: `${inputIdPrefix}_${pk}`,
					maxlength: 255
				}).addClass(`inp inp-txt ${this.inputClassName}`).appendTo($elm);
				break;
			}
		}
		
		return $elm;
	}
}
